import { Outlet } from "react-router-dom";
import Sidebar from '../../Client/Components/Sidebar.jsx';
import { useState, useEffect } from "react";
import { Menu } from "lucide-react";

const Layout = () => {
    const [sidebarOpen, setSidebarOpen] = useState(window.innerWidth >= 1024);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);

    useEffect(() => {
        const handleResize = () => {
            const mobile = window.innerWidth < 1024;
            setIsMobile(mobile);
            if (!mobile) setSidebarOpen(true);
            else setSidebarOpen(false);
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const contentStyle = {
        marginLeft: isMobile ? "0px" : (sidebarOpen ? "260px" : "80px"),
        transition: "0.4s cubic-bezier(0.4, 0, 0.2, 1)",
        minHeight: "100vh",
        background: "var(--bg-main)",
        padding: "24px",
        paddingTop: isMobile ? "80px" : "24px",
    };

    return (
        <div style={{ position: "relative" }}>
            {/* Mobile Header */}
            {isMobile && (
                <div style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    right: 0,
                    height: "64px",
                    background: "#000",
                    display: "flex",
                    alignItems: "center",
                    padding: "0 20px",
                    zIndex: 900,
                    boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
                    justifyContent: "space-between"
                }}>
                    <span style={{ color: "#fff", fontWeight: "700", fontFamily: "Outfit" }}>MG CENTRAL ADMIN</span>
                    <button
                        onClick={() => setSidebarOpen(true)}
                        style={{
                            background: "transparent",
                            border: "none",
                            color: "#fff",
                            cursor: "pointer"
                        }}
                    >
                        <Menu size={24} />
                    </button>
                </div>
            )}

            <Sidebar open={sidebarOpen} setOpen={setSidebarOpen} />

            <div style={contentStyle}>
                <div style={{ maxWidth: "1600px", margin: "0 auto" }}>
                    <Outlet />
                </div>
            </div>
        </div>
    );
};

export default Layout;




























